import React from "react";
// 1. Import Helmet
import { Helmet } from "react-helmet";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { useEffect } from "react";

// Define metadata constants for SEO
const PAGE_TITLE = "Maritime Services Solutions: Ship Brokerage, Legal, & Recruitment | Steminorder";
const PAGE_DESCRIPTION = "Explore Steminorder's comprehensive maritime services, including Ship Brokerage, Mass Message Circulation, Professional Recruitment, Real-Time Reputation, and specialized Legal Assistance.";
const CANONICAL_URL = "https://www.steminorder.com/services";
const OG_IMAGE_URL = "https://www.steminorder.com/images/services-hero.png"; // Use a relevant image

const ServicesPage = () => {

  useEffect(() => {
  if (window.location.hash) {
    const id = window.location.hash.replace('#', '');
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }
}, []);

  return (
    <div>
      <>
        {/* ============================================================
          REACT HELMET INTEGRATION 
          ============================================================
        */}
        <Helmet>
          <title>{PAGE_TITLE}</title>
          <meta name="description" content={PAGE_DESCRIPTION} />
          
          {/* Canonical URL */}
          <link rel="canonical" href={CANONICAL_URL} />

          {/* Open Graph Tags */}
          <meta property="og:title" content={PAGE_TITLE} />
          <meta property="og:description" content={PAGE_DESCRIPTION} />
          <meta property="og:url" content={CANONICAL_URL} />
          <meta property="og:type" content="website" />
          <meta property="og:site_name" content="Steminorder" />
          <meta property="og:image" content={OG_IMAGE_URL} /> 
          
          {/* Twitter Card Tags */}
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content={PAGE_TITLE} />
          <meta name="twitter:description" content={PAGE_DESCRIPTION} />
          <meta name="twitter:image" content={OG_IMAGE_URL} />
        </Helmet>
        
        <Header />
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h4 className="text-center text- text-base pt-10 pb-4 text-breadcrumb font-bold">
                SERVICES
              </h4>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-6 offset-lg-3 col-sm-12">
              <h1 className="text-center  text-5xl font-semibold text-heading">
                Comprehensive Maritime Service Solutions
              </h1>
            </div>
          </div>

          {/* SERVICES SECTION 1 */}
          <div className="row py-5">
            <div className="col-lg-6 col-sm-12">
              <img
                className="img img-responsive"
                src={require("../images/services-1.png")}
                alt="Ship Brokerage Services"
              />
            </div>
            <div className="col-lg-6 col-sm-12">
              <h2 className="w-1/2 font-semibold text-3xl">SHIP BROKERAGE</h2>
              <p className="py-3 leading-loose text-paragraph">
                Steminorder is a global shipping platform designed to provide
                maritime professionals with optimal solutions. <br />
                <br /> Perhaps you represent a ship owner in search for the
                suitable cargo for an appropriate destination promptly. Or a
                charterer looking for a proper merchant vessel to transport a
                certain type of cargo, ASAP. You know exactly what to do so that
                the stem is in order, but do you have all the information to be
                able do what you can do best, and that without wasting time? You
                just might not, if you are not among the almost 91,000 members
                of steminorder.com. Yes, we are talking about a gargantuan
                community located in 225 countries from all over the world,
                updating an average of 1,000 fresh vessel and 3000 fresh cargo
                positions at our portal around the clock.
                <br /> <br /> Now before you ask yourself if you can afford to
                draw on this massive information flow, do ask if you can afford
                not to. We’ve come to know almost 91,000 decision-makers in 23
                years with a clear mind on that, if not a categorical assurance.
              </p>
            </div>
          </div>

          {/* SERVICES SECTION 2 */}
          <div className="row py-5" id="circulation">
            <div className="col-lg-6 col-sm-12">
              <h2 className="w-1/2 font-semibold text-3xl">
                MASS MESSAGE CIRCULATION PLATFORM
              </h2>
              <p className="py-3 leading-loose text-paragraph">
                Time-efficient communication is a key ingredient of a prospering
                business. You will most certainly meet a good many counterparts
                through Steminorder. Just how much time would it take to land
                in, say, a million mailboxes, without being categorized as spam?{" "}
                <br />
                <br /> How about a few seconds?
                <br /> <br />
                Our Circulation Platform powered by Amazon materializes your way
                to contact countless addressees on a private basis, totally
                under your control with the password you designate on Amazon
                servers. <br />
                <br /> This is a professional mailing system where you can group
                interlocutors, send confidential messages, notice exactly when
                your mails are received, how often they were read, know what
                went wrong if an addressee could not be contacted, and
                reconstruct them if need be. <br /> <br />
                Long-standing members enjoy the convenience of a platform that
                had been circulating an average of 1 million mails per day,
                adding up to over 8 billion mails from the beginning of our
                journey. The new mailing system with contemporary servers
                projects an average of 10 million mails on a single day. <br />
                <br /> We project, the sky is the limit.
              </p>
            </div>
            <div className="col-lg-6 col-sm-12">
              <img
                className="img img-responsive"
                src={require("../images/services-2.png")}
                alt="Mass Message Circulation Platform"
              />
            </div>
          </div>

          {/* SERVICES SECTION 3 */}
          <div className="row py-5">
            <div className="col-lg-6 col-sm-12">
              <img
                className="img img-responsive"
                src={require("../images/services-3.png")}
                alt="Recruitment of Maritime Professionals"
              />
            </div>
            <div className="col-lg-6 col-sm-12">
              <h2 className="w-1/2 font-semibold text-3xl">
                RECRUITMENT OF MARITIME PROFESSIONALS
              </h2>
              <p className="py-3 leading-loose text-paragraph">
                A well-organized system plans perfection in any business
                conduct. Yet it’s the people that implement the plan, people
                make the difference on the sea of life. If it hadn’t been for
                your people, your perfect maritime organization would simply
                have drowned. <br />
                <br /> Steminorder matches supply and demand on the seas of this
                wide, wide world not only on the basis of ship and cargo, but
                maritime professionals as well. You might employ this platform
                to discover the appropriate vessel or cargo, contact any company
                for an offer or all possible questions, and drum up business,
                but what happens when there emerge crew-related setbacks in the
                middle of a transport? <br />
                <br /> If you embrace a holistic approach, you just can’t say
                you are not fussed with extrinsic stages of your service. We
                cherish smooth operations on the part of clients until all
                delivery targets are met. That’s why we are currently augmenting
                our recruitment solutions to correspond to a ship crew pool of
                ca. 20,000 professionals from numerous harbors by 2025 God
                willing and the creek don’t rise.
              </p>
            </div>
          </div>

          {/* SERVICES SECTION 4 */}
          <div className="row py-5">
            <div className="col-lg-6 col-sm-12">
              <h2 className="w-1/2 font-semibold text-3xl">
                REAL-TIME REPUTATION
              </h2>
              <p className="py-3 leading-loose text-paragraph">
                Word has it that you’re an excellent business partner.
                Understandably you prefer to do business with your equals. When
                you find one such, though, would you recognize them? Is it
                written on their face? <br></br> <br></br>In a way, yes! It’s
                written on their corporate face brought to you by the
                Steminorder Card functioning both ways.
                <br />
                <br /> On one lane you inform the world of the intrinsic
                features and strengths of your company, create and announce your
                references, reveal performance tracks. On another, you put a
                potential cooperation partner under the microscope. <br></br>
                <br></br> All members are allowed to evaluate and comment on
                given and taken services, and advertise these. Through the
                Steminorder Card you evaluate vessels, companies, completed
                businesses plus fixtures as well as failed ones. This
                interactive method enables a general market norm, standards and
                loyalty. Everyone will distinguish between reliable companies
                and black-listed ones. <br></br>
                <br></br> There are things in this world that should better be
                kept secret. Your proficiency and your judgment of the
                proficiency of others should not. Don't keep such valuable
                remarks to yourself. Please don't.
              </p>
            </div>
            <div className="col-lg-6 col-sm-12">
              <img
                className="img img-responsive"
                src={require("../images/services-4.png")}
                alt="Real-Time Reputation Platform"
              />
            </div>
          </div>

          {/* SERVICES SECTION 5 */}
          <div id="legal" className="row py-5">
            <div className="col-lg-6 col-sm-12">
              <img
                className="img img-responsive"
                src={require("../images/services-5.png")}
                alt="Legal Assistance Services"
              />
            </div>
            <div className="col-lg-6 col-sm-12">
              <h2 className="w-1/2 font-semibold text-3xl">LEGAL ASSISTANCE</h2>
              <p className="py-3 leading-loose text-paragraph">
                To enhance your Steminorder experience, our "Legal Assistance"
                section offers expert legal services and guidance whenever you
                need it. Explore a comprehensive range of legal services
                tailored to address common maritime trade disputes. Submit your
                legal inquiries directly, and our cooperant lawyers at various
                countries will respond promptly to ensure effective resolution.
                Our specialized services include:
                <br />
                <br />
                <br></br>
                <b>1. Shipping Disputes and Contracts:</b> Handling breaches of
                contract, cargo delivery issues, and performance obligations
                with strategic advice and representation.<br></br>
                <b>2. Admiralty and Casualty Response:</b> Immediate legal
                assistance for maritime casualties like collisions, groundings,
                and oil spills, managing investigations and claims efficiently.
                <br></br>
                <b>3. Maritime Security Issues and Piracy:</b> Expert counsel on
                piracy, armed robbery, and other security threats, ensuring
                vessel and cargo safety.<br></br>
                <b>4. Maritime Insurance:</b> Assistance with policy
                interpretation, coverage disputes, and indemnity claims,
                ensuring full insurance benefits.<br></br>
                <b>5. Shipbuilding, Repair, and Conversion Disputes:</b>{" "}
                Resolving disputes related to shipbuilding, repair, and
                conversion contracts efficiently.<br></br>
                <b>6. Ship Sale and Purchase (MOA) Disputes:</b> Comprehensive
                support for disputes related to ship sale and purchase, ensuring
                smooth transactions.
              </p>
            </div>
          </div>

          {/* SERVICES SECTION 6 */}
          <div className="row py-5">
            <div className="col-lg-6 col-sm-12">
              <h2 className="w-1/2 font-semibold text-3xl">
                MISCELLANEOUS BUSINESS OPPORTUNITIES
              </h2>
              <p className="py-3 leading-loose text-paragraph">
                Each of the five major services above partakes of a quality
                touch that distinguishes Steminorder from competitors. We still
                figured, let’s top it off with a special bundle of
                opportunities. In the end you just can’t beat a bonus now, can
                you? <br></br>
                <br></br>
                Imagine finding a suitable cargo or vessel, but then investing a
                little bit more of your time to find out that you can buy or
                sell something else quite lucratively through our Auxiliary
                Trade Center. <br></br>
                <br></br>
                Why settle for recruiting the best professionals available in
                some remote corner of the world when you can additionally enjoy
                port-specific support by a local agency as to ship supplies for
                instance? <br></br>
                <br></br>
                An occasion to consult with experts of maritime law on a current
                issue might just as well open doors for future ship-trading
                opportunities through new acquaintances in an ever-growing
                network. <br></br>
                <br></br>
                How about integrating valuable information from our regular
                lines update in a message you send to innumerable recipients
                through the Steminorder circulation system? <br></br>
                <br></br>
                The more you benefit from our services, the better they’ll get.
                Let's boost business together!
              </p>
            </div>
            <div className="col-lg-6 col-sm-12">
              <img
                className="img img-responsive"
                src={require("../images/services-7.png")}
                alt="Miscellaneous Business Opportunities"
              />
            </div>
          </div>
        </div>
        <Footer />
      </>
    </div>
  );
};

export default ServicesPage;